/* snippet: https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71 */
import React from 'react'
import './styles.scss'
import { Spring, config } from 'react-spring/renderprops.cjs'
import { CompositeDisposable } from 'react-spring/web.cjs'
import renderHTML from 'react-render-html'
import Background from 'images/counter.svg'

function convertToEmissions(seconds) {
  let tons = seconds * 0.017935058346017
  let output = '0 Kilogramm CO2-Äquivalente'

  if (tons < 1) {
    output =
      '<div className="big-number">' +
      Math.floor(tons * 1000).toString() +
      '</div><span className="unit">Kilogramm</span>'
  } else {
    output =
      '<div className="big-number tons">' +
      (Math.round((tons + Number.EPSILON) * 100) / 100).toString() +
      '</div><div className="unit tons">Tonnen</div>'
  }

  return output
}

export class EmissionCounter extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      counterState: 'init',
      counterTime: 31536000 // set this to seconds limit
    }
    this.toggleDownload = this.startCounter.bind(this)
  }

  componentDidMount() {
    this.startCounter()
  }

  startCounter() {
    this.setState({ counterState: 'running' })
  }

  render() {
    return (
      <div className='counter-wrapper'>
        <object type='image/svg+xml' data={Background}>
          svg-animation
        </object>
        <Spring
          from={{ number: 0 }}
          to={{
            number:
              this.state.counterState === 'running' ? this.state.counterTime : 0
          }}
          config={{
            duration:
              this.state.counterState === 'running'
                ? this.state.counterTime * 1000
                : 0
          }}
        >
          {props => (
            <div className={'counter ' + this.state.counterState}>
              {this.state.counterState === 'running'
                ? renderHTML(convertToEmissions(props.number).replace('.', ','))
                : ''}
              <div className='explain'>
                CO2-Äquivalente wurden von D29 ausgestossen, seit Sie diesen
                Artikel lesen.
              </div>
            </div>
          )}
        </Spring>
      </div>
    )
  }
}
